module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAMVJREFUOE+dk7ERwjAQBO8aYAggMiF0AJ1AAGXQB81AARBRDzBDQnKMPG/m/QhbRpFk63Ze9/eEW5LG6Ujy5r937dn8lLQCcLbzjuSxBOIBewAHE70AbEogHjABcAWwGAL5AJJIUmXPKIa0AP9AvgAOcgEw73tOFvAD8gRQkbz77nQBZuZHU0U5QFIUp7auSZ5iNnImFovr1IYoDxK3AJKmFiTvfLbsrImSYpR7xbGCJYDU+7S2OcNywxU9GNk4P0omMd15A2tyWhHIlk5CAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down5.png
// module id = 0f+/
// module chunks = 48